/** The preview endpoints answer the raw base64 string, the platform's
    `{ result: <base64> }` envelope, or — for the multi-document preview —
    an array of base64 strings (one PDF per document id). Accept all of
    them, fail loudly on anything else (an object reaching `atob`/`.replace`
    crashed the preview tab). */
export function previewPayloadToBase64(payload: unknown): string {
  if (typeof payload === 'string') return payload;
  const result = (payload as { result?: unknown } | null | undefined)?.result;
  if (typeof result === 'string') return result;
  console.warn('sales:preview unexpected payload shape', payload);
  throw new Error('Belegvorschau: unerwartetes Antwortformat');
}

export function previewPayloadToBase64List(payload: unknown): string[] {
  const value =
    payload && typeof payload === 'object' && 'result' in payload
      ? (payload as { result: unknown }).result
      : payload;
  if (typeof value === 'string') return [value];
  if (
    Array.isArray(value) &&
    value.length > 0 &&
    value.every((entry) => typeof entry === 'string')
  ) {
    return value;
  }
  console.warn('sales:preview unexpected payload shape', payload);
  throw new Error('Belegvorschau: unerwartetes Antwortformat');
}
